import {styled} from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`
    .ant-list .ant-list-item{
        display: block !important;
    }
  .ant-card-body {
    padding: 0 10px;
  }

`;